import request from '@/plugins/axios'

//删除任务
export function deleteTask(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/deleteTask/' + params,
    method: 'get'
  })
}

//创建任务
export function addTask(data) {
  return request({
    url: '/workflow/pictureArticleFilterTask/addTask',
    method: 'post',
    data
  })
}

//查询任务基本信息
export function getTask(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/getTask/' + params,
    method: 'get'
  })
}

//获取已审核的图片列表
export function listCheck(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/listCheck',
    method: 'get',
    params
  })
}

//获取已选入的图片列表
export function listSelect(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/listSelect',
    method: 'get',
    params
  })
}

//获取任务列表
export function listTask(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/listTask',
    method: 'get',
    params
  })
}

//保存审核通过的图片
export function checkPictures(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/checkPictures',
    method: 'post',
    params
  })
}

//选入图片
export function selectPicture(data) {
  return request({
    url: '/workflow/pictureArticleFilterTask/selectPicture',
    method: 'post',
    data
  })
}


//设置任务状态
export function setTaskStatus(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/setTaskStatus',
    method: 'post',
    params
  })
}


//送审
export function toCheck(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/toCheck',
    method: 'post',
    params
  })
}


//取消选入图片
export function unSelectPicture(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/unSelectPicture',
    method: 'post',
    params
  })
}


//查看留言及动态
export function listMessage(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/listMessage',
    method: 'get',
    params
  })
}

//查看留言及动态
export function addMessage(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/addMessage',
    method: 'post',
    params
  })
}


//获取送审目标用户
export function listCheckUser() {
  return request({
    url: '/workflow/pictureArticleFilterTask/listCheckUser',
    method: 'get'
  })
}

//屏蔽图片筛选任务的投稿
export function rejectPictureArticle(data) {
  return request({
    url: '/workflow/pictureArticleFilterTask/rejectPictureArticle',
    method: 'post',
    data
  })
}

//获取备选稿件列表
export function listArticle(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/listArticle',
    method: 'get',
    params
  })
}


//获取流程列表
export function listWorkflow(params) {
  return request({
    url: '/workflow/pictureArticleFilterTask/listWorkflow',
    method: 'get',
    params
  })
}